import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import CookieConsent from './components/common/cookieconsent';

import App from '@/App';
import PrivacyPolicy from '@/pages/privacy-policy';
import ResourceLibrary from '@/pages/resources';
import BlogList from '@/pages/blog';
import Mobile from '@/pages/mobile';
import ContactPage from '@/pages/contact';
import ProfilePage from '@/pages/ralphbrooks';
import FriscoPage from '@/pages/frisco';
import ImmigrationLandingPage from '@/pages/immigration';
import LocationsPage from './pages/locations';

// Import all .tsx files under the locations directory
const locationModules = import.meta.glob<{ default: React.ComponentType<any> }>([
  './locations/**/*.tsx',
]);

// Generate location routes
const locationRoutes = Object.entries(locationModules).map(([modulePath, moduleLoader]) => {
  let routePath = modulePath
    .replace('./locations', '')
    .replace(/\.tsx$/, '')
    .replace(/\/index$/, '')
    .toLowerCase();

  const Component = lazy(moduleLoader);
  return { path: routePath, Component };
});

// Import dynamic page modules
const modules = import.meta.glob<{
  default: React.ComponentType<any>;
}>([
  './mobile-notary/**/*.tsx',
  './resources/**/*.tsx',
  './events/**/*.tsx',
  './customer-stories/**/*.tsx',
  './community/**/*.tsx',
  './demo/**/*.tsx',
  './solutions/**/*.tsx',
  './blog/**/*.tsx',
  './legal/**/*.tsx',
  './verify/**/*.tsx', // Added the new "Verify" directory for the I-9 funnel
]);

// Generate route objects from the modules
const routes = Object.keys(modules).map((modulePath) => {
  // Get the route path from the module path
  let routePath = modulePath
    .replace('./', '/')
    .replace(/\.tsx$/, '')
    .replace(/\/index$/, '')
    .toLowerCase();

  // Replace [param] with :param for dynamic routes
  routePath = routePath.replace(/\[(.+?)\]/g, ':$1');

  // Lazy load the component
  const Component = lazy(() => modules[modulePath]());

  return {
    path: routePath,
    Component,
  };
});

const MainRouter = () => (
  <Router>
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/immigration" element={<ImmigrationLandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/resources" element={<ResourceLibrary />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/mobile" element={<Mobile />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/ralphbrooks" element={<ProfilePage />} />
        <Route path="/frisco" element={<FriscoPage />} />
        <Route path="/locations" element={<LocationsPage />} />

        {/* Render locationRoutes */}
        {locationRoutes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}

        {/* Render dynamic routes */}
        {routes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
      </Routes>
    </Suspense>
    <CookieConsent />
  </Router>
);

export default MainRouter;